import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {
  transform(value: string | undefined): string {
    if (!value) {
      return '';
    }

    const parts = value.split(/[- ]/);

    // Extract day, month, and year based on the format
    let day, month, year;
    if (parts[0].length === 4) {
      // Format: YYYY-MM-DD
      day = parts[2];
      month = parts[1];
      year = parts[0];
    } else {
      // Format: DD-MM-YYYY
      day = parts[0];
      month = parts[1];
      year = parts[2];
    }

    // Extract time
    const time = parts[3];

    // Construct a new Date object using the extracted parts
    const date = new Date(`${year}-${month}-${day}T${time}`);

    // Get the current time zone offset in minutes
    const localOffsetMinutes = new Date().getTimezoneOffset();

    // Adjust the time by the local time zone offset
    date.setHours(date.getHours() - localOffsetMinutes / 60);

    // Format the adjusted date and time
    const formattedDate = `${date.getDate()}.${
      date.getMonth() + 1
    }.${date.getFullYear()} ${date.toTimeString().slice(0, 8)}`;

    return formattedDate;
  }
}
